(function () {
  'use strict';

  /* @ngdoc object
   * @name main.administradors
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.administradors', [
      'ui.router'
    ]);
}());
